__turbopack_context__.v({
  "card": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__card",
  "circleButton": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__circleButton",
  "flushBottom": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__flushBottom",
  "flushTop": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__flushTop",
  "heading": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__heading",
  "headline": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__headline",
  "hoverImage": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__hoverImage",
  "hoverImageActive": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__hoverImageActive",
  "image": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__image",
  "imageHidden": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__imageHidden",
  "imageRight": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__imageRight",
  "imageWrapper": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__imageWrapper",
  "inner": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__inner",
  "linkItem": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__linkItem",
  "linkItemLabel": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__linkItemLabel",
  "linkList": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__linkList",
  "media": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__media",
  "newBadge": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__newBadge",
  "root": "BlockFeaturedCategoryNavigation-module-scss-module__isboLW__root",
});
